__turbopack_context__.v({
  "crespon": "tPlIkq_crespon",
  "root": "tPlIkq_root",
});
